export default String.raw`
{% assign SiteMap = ShopSiteMap.SiteMap -%}

<div class="page-padding">

<h2 class="sitemap-title">
    {{ translations.SiteMap }}
</h2>

<section class="sitemap-container">
    {% assign siteMapBase = page.BaseHref -%}
    <ul class="sitemap-sections">
        {% for group in SiteMap %}
            <li>
            <section class="sitemap-section">
                <h3 class="sitemap-group-title">
                {{ group.Name }}
                </h3>
                <ul class="sitemap-links">
                {% for page in group.SitemapGroupLangs %}
                    <li>
                        {% capture siteMapHref -%}{% include 'partials/common/user-link.html', userLink: page.Url, userBase: siteMapBase -%}{% endcapture -%}
                        <a href="{{ siteMapHref }}">{{ page.Name }}</a>
                    </li>
                {% endfor %}
                </ul>
            </section>
            </li>
        {% endfor %}
    </ul>
</section>

</div>
`